import React, {useState} from 'react';
import {Box, Button, Grid} from '@mui/material';
import {Link} from 'react-router-dom';
import {JobDetailsTab} from '../../../components/ai/review/common/JobDetails/JobDetailsTab';

const AIReviewJobDetailsDemo: React.FC = () => {
  const [jobId, setJobId] = useState<string | number>(101);

  return (
    <Box className="ai-thinking-demo">
      <h1>AIReviewJobDetails</h1>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <Button
        onClick={() => setJobId((prev) => (prev === 101 ? 102 : 101))}
        data-testid="aireview-job-details-demo-button"
      >
        Switch Job
      </Button>
      <hr />
      <Grid container spacing={2} paddingTop={10} className="job-details-box">
        <JobDetailsTab
          jobId={jobId}
          getJobDetailData={null}
          handleRefetchJobDetails={() => undefined}
        />
      </Grid>
    </Box>
  );
};

export default AIReviewJobDetailsDemo;
